import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import { Icon, Skeleton } from '../../components/ui';
import { coverOf, kindOf, kindLabel, photoLabel, pickHome } from './galleryShared';
import './gallery.css';

/**
 * 홈 "Recent work" 스트립 — 앨범 다섯 개의 대표 사진. 첫 앨범이 크게.
 * 갤러리가 비어 있거나(관리시스템 미연결) 실패하면 섹션을 아예 그리지 않는다.
 */
export default function HomeGallery() {
  const { data, isLoading, isError } = useQuery({ queryKey: ['gallery'], queryFn: () => api.gallery.list(), staleTime: 5 * 60 * 1000 });
  const items = pickHome(data, 5);

  if (isError || (!isLoading && items.length === 0)) return null;

  return (
    <section className="sec home-gallery">
      <div className="wrap">
        <div className="sec-head">
          <div>
            <div className="kicker">Recent work</div>
            <h2 className="sec-title">Cut in Blacktown, fitted all over Sydney.</h2>
            <p className="sec-lede">
              Parts that left the floor and the workshop they were cut in — photos updated as jobs go out.
            </p>
          </div>
          <Link to="/gallery" className="btn btn-s">
            See the gallery
            <Icon name="arrowRight" />
          </Link>
        </div>

        <div className="hg-grid">
          {isLoading
            ? [0, 1, 2, 3, 4].map(i => <Skeleton key={i} h="100%" r={14} className="g-card" />)
            : items.map(g => (
                <Link key={g.id} to={`/gallery?item=${g.id}`} className="g-card">
                  <figure className="g-fig">
                    <img src={coverOf(g)} alt={g.title} loading="lazy" />
                    <span className={`g-kind g-kind--${kindOf(g).toLowerCase()}`}>{kindLabel(kindOf(g))}</span>
                    <span className="g-count"><Icon name="image" size={12} />{photoLabel(g)}</span>
                  </figure>
                  <figcaption className="g-cap">
                    <b>{g.title}</b>
                  </figcaption>
                </Link>
              ))}
        </div>
      </div>
    </section>
  );
}
